import * as HomeFeaturesUploads from "$lib/data/generated/uploads/home/Features/uploads.js";
import * as HomeFeaturesHeroUploads from "$lib/data/generated/uploads/home/Features Hero/uploads.js";
import * as HomeFeaturesHeroContentUploads from "$lib/data/generated/uploads/home/Features Hero Content/uploads.js";
import * as HomeFeaturesSpecializeUploads from "$lib/data/generated/uploads/home/Features Specialize/uploads.js";
import * as HomeFeaturesThomasUploads from "$lib/data/generated/uploads/home/Features Thomas/uploads.js";
import * as HomeHeadUploads from "$lib/data/generated/uploads/home/Head/uploads.js";
import * as HomeHeroUploads from "$lib/data/generated/uploads/home/Hero/uploads.js";
import * as HomeHomeUploads from "$lib/data/generated/uploads/home/Home/uploads.js";
import * as HomeSideBySideUploads from "$lib/data/generated/uploads/home/SideBySide/uploads.js";
import * as HomeSideBySide02Uploads from "$lib/data/generated/uploads/home/SideBySide 02/uploads.js";
import * as HomeTestimonialsUploads from "$lib/data/generated/uploads/home/Testimonials/uploads.js";

export const uploads = {
  ...HomeFeaturesUploads.uploads,
  ...HomeFeaturesHeroUploads.uploads,
  ...HomeFeaturesHeroContentUploads.uploads,
  ...HomeFeaturesSpecializeUploads.uploads,
  ...HomeFeaturesThomasUploads.uploads,
  ...HomeHeadUploads.uploads,
  ...HomeHeroUploads.uploads,
  ...HomeHomeUploads.uploads,
  ...HomeSideBySideUploads.uploads,
  ...HomeSideBySide02Uploads.uploads,
  ...HomeTestimonialsUploads.uploads
};
